import { BehaviourDataActionTypes } from '../constants/ApiConstants';

const initialState = {
    /* application state for timer */
    isRecordDurationRenderTrue: true,
    isStart: [],
    isSave: [],
    secondsElapsed: [],
    incrementer: [],
    newIncrementer: [],
    savePatinetRecordDurationData: null
};

export default (state = initialState, { type, payload }) => {
    switch (type) {

        /* Record Duration */

        case BehaviourDataActionTypes.set_isRecordDurationRenderTrue.SUCCESS:
            return {
                ...state,
                loading: false,
                isRecordDurationRenderTrue: payload,
            };

        case BehaviourDataActionTypes.start_recordDurationTimer.SUCCESS:
            return {
                ...state,
                loading: false,
                isStart: payload
            }
        case BehaviourDataActionTypes.start_secondsElapsed.SUCCESS:
            return {
                ...state,
                loading: false,
                secondsElapsed: payload
            }
        ////////
        case BehaviourDataActionTypes.start_secondsElapsedReset.SUCCESS: //"start_secondsElapsedReset_success"
        
        let { secondsElapsed,isStart} = payload;
        return {
                ...state,
                loading: false,
                secondsElapsed: secondsElapsed,
                isStart:isStart,
                newIncrementer:[],
                incrementer:[]
            }

        ///////
        case BehaviourDataActionTypes.post_patinetRecordDurationData.REQUEST:
            return {
                ...state,
                loading: true,
                savePatinetRecordDurationData: payload
            }
        case BehaviourDataActionTypes.post_patinetRecordDurationData.SUCCESS:
            return {
                ...state,
                loading: false,
                savePatinetRecordDurationData: payload
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/reducers/recordDurationCustomReducer.js